export default class Modal extends React.PureComponent
  constructor: (props) ->
    super(props)

    @state =
      name: ''

    @handleChange        = @handleChange.bind(this)
    @handleSubmit        = @handleSubmit.bind(this)
    @triggerInputKeyDown = @triggerInputKeyDown.bind(this)

  componentDidMount: ->
    modal = document.getElementById(@props.modalId)
    modal.addEventListener('shown.bs.modal', =>
      $('input#edited-book-name').trigger('focus')
    )
    # Prevent accessibility error in the console (focus is still inside the modal after it closed)
    # See: https://github.com/twbs/bootstrap/issues/41005#issuecomment-2497670835
    modal.addEventListener('hide.bs.modal', =>
      focusedElement = document.activeElement
      focusedElement.blur() if modal.contains(focusedElement)
    )

  componentDidUpdate: (prevProps) ->
    # Reset name field when the edited book changes
    @setState(name: @props.book.name) if @props.book && @props.book != prevProps.book

  handleChange: (e) =>
    @setState(name: e.target.value)

  handleSubmit: ->
    @props.updateBook(@state.name)

  triggerInputKeyDown: (e) ->
    @handleSubmit() if e.code == 'Enter' && @nameIsValid()

  nameIsValid: ->
    @state.name.trim() != ''

  render: ->
    classes =  'modal'
    classes += ' fade' if @props.environment != 'test'

    <div className={classes} id={@props.modalId} tabIndex="-1" aria-labelledby={"#{@props.modalId}-label"} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          { @renderHeader() }
          { @renderBody()   }
          { @renderFooter() }
        </div>
      </div>
    </div>

  renderHeader: ->
    <div className="modal-header">
      <h4 id={"#{@props.modalId}-label"} className="modal-title">
        Rename book
      </h4>
      <button type="button"
              className="btn-close"
              aria-label="Close"
              onClick={@props.hideModal} />
    </div>

  renderBody: ->
    <div className="modal-body">
      <label htmlFor="edited-book-name" className="form-label">
        Name
      </label>
      <input id="edited-book-name"
             className="form-control"
             type="text"
             value={@state.name}
             onChange={@handleChange}
             onKeyDown={@triggerInputKeyDown} />
    </div>

  renderFooter: ->
    <div className="modal-footer">
      <button className="btn btn-cancel"
              onClick={@props.hideModal}>
        Cancel
      </button>
      <button type="submit"
              className="btn btn-primary"
              onClick={@handleSubmit}
              disabled={!@nameIsValid()}>
        Update
      </button>
    </div>
